import './Match.css';

import React from 'react';
import Card from '../../Card/Card';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import STATUS from '../Constants';


const Match = (props) => {
  // Set the appropriate message
  const message = props.finalMatch ? 'You\'ve found them all!' : 'It\'s a match!';
  const matchingCards = props.cards.filter(card => card.flipped && card.matched);

  const onAnimationEnd = (event) => {
    if (event.animationName === 'moveFromRight' ||
        event.animationName === 'flipBackFade') {

      const timeout = event.animationName === 'moveFromRight' ? 2500 : 500;

      // Add a little bit of delay before calling the callback
      setTimeout(() => {
        props.callback();
      }, timeout);
    }
  }

  const matchClass = classnames(
    'Match',
    {'Match--intro': props.status === STATUS.INTRO_BAD_PAIR || props.status === STATUS.INTRO_GOOD_PAIR || props.status === STATUS.INTRO_END},
  )

  return (
  <CSSTransition
    in={props.showMatch}
    timeout={1000}
    unmountOnExit
    classNames="fade">
      <div className={matchClass}>
        {
          matchingCards.map((card, index) => {
            const classes = classnames(
              'Match__col',
              {'moveFromLeft' : props.status !== STATUS.INTRO_END && index === 0},
              {'moveFromRight' : props.status !== STATUS.INTRO_END && index === 1},
              {'flipBackFade' : props.status === STATUS.INTRO_END}
            )

            return (
              <div key={index} className={classes} onAnimationEnd={onAnimationEnd.bind(this)}>
                <Card
                matched={card.matched}
                value={card.value}
                flipped={card.flipped}
                type="matching" />
              </div>
            )
          })
        }

        {props.status !== STATUS.INTRO_BAD_PAIR && props.status !== STATUS.INTRO_GOOD_PAIR && props.status !== STATUS.INTRO_END ? (
          <div className="Match__message title-md">
            {message}
          </div>
        ) : ('')}
      </div>
    </CSSTransition>
  )
}

export default Match;



// WEBPACK FOOTER //
// ./src/components/du/Game/Match/Match.js